const roles = {
    page_title: 'نقش‌ها',
    title: 'نقش‌ها',
    subtitle: 'نقش‌ها شامل مجوزهایی هستند که تعیین می‌کنند کاربر چه کاری می‌تواند انجام دهد. RBAC از نقش‌ها برای اعطای دسترسی کاربران به منابع برای اقدامات خاص استفاده می‌کند.',
    create: 'ایجاد نقش',
    role_name: 'نام نقش',
    role_type: 'نوع نقش',
    type_user: 'کاربر',
    type_machine_to_machine: 'ماشین به ماشین',
    role_description: 'توضیحات',
    role_name_placeholder: 'نام نقش خود را وارد کنید',
    role_description_placeholder: 'توضیحات نقش خود را وارد کنید',
    col_roles: 'نقش‌ها',
    col_type: 'نوع',
    col_description: 'توضیحات',
    col_assigned_entities: 'اختصاص‌یافته',
    user_counts: '{{count}} کاربر',
    application_counts: '{{count}} برنامه',
    user_count: '{{count}} کاربر',
    application_count: '{{count}} برنامه',
    assign_permissions: 'اختصاص مجوزها',
    create_role_title: 'ایجاد نقش',
    create_role_description: 'از نقش‌ها برای سازماندهی مجوزها و اختصاص آن‌ها به کاربران استفاده کنید.',
    create_role_button: 'ایجاد نقش',
    role_created: 'نقش {{name}} با موفقیت ایجاد شد.',
    search: 'جستجو بر اساس نام نقش، توضیحات یا شناسه',
    placeholder_title: 'نقش‌ها',
    placeholder_description: 'نقش‌ها گروهی از مجوزها هستند که می‌توانند به کاربران اختصاص یابند. قبل از ایجاد نقش، حتماً ابتدا مجوز اضافه کنید.',
    assign_roles: 'اختصاص نقش‌ها',
    management_api_access_notification: 'برای دسترسی به Management API مربوط به Logto، نقش‌هایی با مجوزهای Management API انتخاب کنید <flag/>.',
    with_management_api_access_tip: 'این نقش ماشین به ماشین شامل مجوزهای Management API مربوط به Logto است',
    role_creation_hint: 'نقش مناسب را پیدا نمی‌کنید؟ <a>ایجاد نقش</a>',
};
export default Object.freeze(roles);
